// _zf-mediaquery.js

// initialize foundation
$(document).ready(function() {
  $(document).foundation();
});

//
// EOF
//
